// 홈 — 검차 신청 방법 3택 가로 스트립 (Jin 2026-09-23: 사이드 하단 카드 → CTA 바로 아래 가로 배치).
// 클릭 = /main/s/request?method=photo|link|manual — 신청 화면이 그 방식을 선택된 상태로 연다.
import React from 'react';
import { T, R } from '../../../theme';
import { useT } from '../../../../i18n/I18nProvider';
import { Glyph } from './Thumb';

export var METHODS = [
  ['photo', 'simpleOcrTitle', 'simpleOcrSub'],
  ['link', 'simpleB3LinkTitle', 'simpleB3LinkSub'],
  ['manual', 'simpleManualTitle', 'simpleManualSub']
];
var GLYPH = { photo: 'photo', link: 'link', manual: 'pen' };

var row = { display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 10 };
var item = { display: 'flex', alignItems: 'flex-start', gap: 10, padding: '11px 13px', minWidth: 0, textAlign: 'start',
  background: T.card, border: '1px solid ' + T.bd, borderRadius: R.card, cursor: 'pointer', fontFamily: 'inherit', color: T.ink };
var icon = { width: 30, height: 30, borderRadius: R.md, background: T.accentTint, color: T.accentPress, display: 'grid', placeItems: 'center', flex: 'none' };
var tx = { minWidth: 0 };
var ttl = { display: 'block', fontSize: 12.5, fontWeight: 800, color: T.ink };
var sub = { display: '-webkit-box', fontSize: 11.5, color: T.dim, lineHeight: 1.5, marginTop: 2,
  overflow: 'hidden', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' };

/// props: { onPick(method) }
function MethodStrip(props) {
  var t = useT();
  return (<div className="ss-methods" style={row}>
    {METHODS.map(function (m) {
      return (<button key={m[0]} type="button" data-method={m[0]} style={item}
        onClick={function () { props.onPick(m[0]); }}>
        <span style={icon}><Glyph name={GLYPH[m[0]]} size={16} /></span>
        <span style={tx}>
          <span style={ttl}>{t(m[1])}</span>
          <span style={sub}>{t(m[2])}</span>
        </span>
      </button>);
    })}
  </div>);
}

export default MethodStrip;
